module.exports = __webpack_public_path__ + "static/media/projects.22a5a4b9.svg";